module.exports = __webpack_public_path__ + "c97435a44b8d1ec549f8e32eb4b5691e.jpg";